import './App.css';
import Footer from './Footer';
import Header from './Header';
import ImageBlender from './Imageblender';
import Main from './Main';


function App() {
  return (
    <div className="App">
      <Header />
      <Main />
      {/*<ImageBlender />*/}
      <Footer />
    </div>
  );
}

export default App;
